import { presentStatus } from './adminPresentation';

const StatusChip = ({ value, label }) => {
  const status = presentStatus(value);
  return <span className={`sa-status-chip sa-status-chip--${status.tone}`}><span className="sa-status-chip__dot" aria-hidden="true" />{label || status.label}</span>;
};

export default StatusChip;
